import { TableBody, TableHeader, TableRow } from '@/components/bp/bp-ui';
import { ReactNode } from 'react';
import { Table, TableCell, TableHeaderCell } from '@/components/bp/bp-ui';

export interface IBPTableColumn<T> {
    accessor: string;
    header: string,
    Cell?: (item: T) => ReactNode;
}

export interface IBPSimpleTableProps<T> {
    columns: Array<IBPTableColumn<T>>;
    data: Array<T>;
}

function BPSimpleTable<T>({ columns, data }: IBPSimpleTableProps<T>) {
    return (
        <Table>
            <TableHeader>
                <TableRow>
                    {columns.map(col => (
                        <TableHeaderCell key={`hcol${col.accessor}`}>
                            {col.header}
                        </TableHeaderCell>
                    ))}
                </TableRow>
            </TableHeader>
            <TableBody>
                {data.map((row, index) => (
                    <TableRow key={`row${index}`}>
                        {columns.map(col => (
                            <TableCell key={`bcol${col.accessor}`}>
                                {col.Cell ? col.Cell(row) : (row as any)[col.accessor]}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}

export default BPSimpleTable;